var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidateError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM10.125 4.5C10.125 5.12132 9.62132 5.625 9 5.625C8.37868 5.625 7.875 5.12132 7.875 4.5C7.875 3.87868 8.37868 3.375 9 3.375C9.62132 3.375 10.125 3.87868 10.125 4.5ZM7.875 7.875C7.25368 7.875 6.75 8.37868 6.75 9C6.75 9.62132 7.25368 10.125 7.875 10.125V13.5C7.875 14.1213 8.37868 14.625 9 14.625H10.125C10.7463 14.625 11.25 14.1213 11.25 13.5C11.25 12.8787 10.7463 12.375 10.125 12.375V9C10.125 8.37868 9.62132 7.875 9 7.875H7.875Z",
    fill: "#FF502D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidateError);
export default __webpack_public_path__ + "static/media/validateError.c01bd2485ce4be03365874faa9571703.svg";
export { ForwardRef as ReactComponent };